import { gql } from 'urql';

const HowDoYouGetPaidQuery = gql`
  query HowDoYouGetPaid {
    howDoYouGetPaid {
      __typename
      ... on HowDoYouGetPaidSuccess {
        title
        subtitle
        options {
          id
          type
          title
          clickAnalytics {
            name
            properties {
              key
              value
            }
          }
        }
      }
      ... on HowDoYouGetPaidError {
        code
        message
        errorTitle: title
      }
    }
  }
`;

export default HowDoYouGetPaidQuery;
